module.exports = __webpack_public_path__ + "img/avatar3.3f0f3550.png";